import type { IconNode } from '../types';

/**
 * @name shower
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOSAxMFY4YTIgMiAwIDAgMSAyLTJoNmEyIDIgMCAwIDEgMiAydjIiIC8+CiAgPHBhdGggZD0iTTcgMTBoMTQiIC8+CiAgPHBhdGggZD0iTTMgMjJWNGEyIDIgMCAwIDEgMi0yaDdhMiAyIDAgMCAxIDIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xMCAxNGguMDEiIC8+CiAgPHBhdGggZD0iTTE0IDE0aC4wMSIgLz4KICA8cGF0aCBkPSJNMTggMTRoLjAxIiAvPgogIDxwYXRoIGQ9Ik05IDE4aC4wMSIgLz4KICA8cGF0aCBkPSJNMTQgMThoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xOSAxOGguMDEiIC8+CiAgPHBhdGggZD0iTTggMjJoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMmguMDEiIC8+CiAgPHBhdGggZD0iTTIwIDIyaC4wMSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/shower
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shower: IconNode = [
  ['path', { d: 'M9 10V8a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2', key: '1wzffz' }],
  ['path', { d: 'M7 10h14', key: '1kgo7c' }],
  ['path', { d: 'M3 22V4a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v2', key: '1dg02h' }],
  ['path', { d: 'M10 14h.01', key: 'ssrbsk' }],
  ['path', { d: 'M14 14h.01', key: 'uax65s' }],
  ['path', { d: 'M18 14h.01', key: '6eno8s' }],
  ['path', { d: 'M9 18h.01', key: '2qx7s0' }],
  ['path', { d: 'M14 18h.01', key: '1y05er' }],
  ['path', { d: 'M19 18h.01', key: '1d9h01' }],
  ['path', { d: 'M8 22h.01', key: 'vy2k4o' }],
  ['path', { d: 'M14 22h.01', key: '1v0jtx' }],
  ['path', { d: 'M20 22h.01', key: 'mnuvyq' }],
];

export default shower;
